export default {"src":"/_next/static/media/happyFace.4a369e8d.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};